import React, { useEffect, useState } from "react";
import { Input, InputGroup } from "reactstrap";
import searchIcon from "../../assets/icon/search.svg";

const SearchButtons = (props) => {
  const { InSize, placeHolder, data, setFilterData, row } = props;
  const [searchData, setSearchData] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // const handleFilter = (e) => {
  //   const value = e.target.value.toLowerCase();
  //   setSearchData(value);

  //   const filtered = data.filter((item) =>
  //     item.patientName?.toLowerCase().includes(value.toLowerCase()) ||
  //     item.patientName?.toLowerCase().includes(value.toLowerCase()) ||
  //     item.patient?.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setFilterData(filtered.length ? filtered : []);
  //   if(value == ''){
  //    setFilterData(row)
  //   }
  // };
  // useEffect(() => {
  //   if (searchData === '') {
  //     setFilterData(row); // show all
  //   }
  // }, [searchData]);

  const handleFilter = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchData(value);

    const filtered = data.filter(
      (item) =>
        item.patientName?.toLowerCase().includes(value) ||
        item.patient?.toLowerCase().includes(value)
    );

    // setFilterData(filtered.length ? filtered : []);

    // Get suggestions (unique patient names or similar)
    const suggestList = filtered.map((item) => item.patient).filter(Boolean);
    const uniqueSuggestions = [...new Set(suggestList)].slice(0, 4); // Limit to 5

    setSuggestions(value ? uniqueSuggestions : []);

    if (value === "") {
      setFilterData(row);
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchData(suggestion);
    setSuggestions([]);

    const filtered = data.filter(
      (item) =>
        item.patientName?.toLowerCase().includes(suggestion.toLowerCase()) ||
        item.patient?.toLowerCase().includes(suggestion.toLowerCase())
    );
    setFilterData(filtered.length ? filtered : []);
  };
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        position: "relative",
      }}
    >
      <InputGroup style={{ width: `${InSize}px ` }}>
        <Input
          type="text"
          value={searchData}
          onChange={handleFilter}
          placeholder={placeHolder}
          className="inv-input"
        />
        <img src={searchIcon} className="p-1" alt="not available" />
      </InputGroup>
      {suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            zIndex: "10000",
            top: "43px",
            background: "white",
            border: "1px solid #ccc",
            listStyle: "none",
            maxHeight: "150px",
            overflowY: "auto",
            width: InSize,
            fontSize: "13px",
            filter: " drop-shadow(rgba(12, 12, 13, 0.05) 2px 2px 4px)",
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchButtons;
